/**
 * The signed-in back-office operator, sent to Digital Services on the calls
 * that export or bulk-read customer data so DS can record who did it
 * (abo-data-access-guard task 05). DS stores the e-mail as a claim and marks
 * it verified only when the FusionAuth token verifies; the token is never
 * required.
 */
export interface OperatorIdentity {
  email?: string;
  token?: string;
}

export const OPERATOR_EMAIL_HEADER = "x-afy-user-email";
export const OPERATOR_TOKEN_HEADER = "x-afy-operator-token";

/**
 * The operator headers for ONE request, or undefined when there is nothing
 * to send. Never put them on the shared axios instance: DS also reads
 * `x-afy-user-email` to resolve which MEMBER some api-key requests are
 * about.
 */
export const operatorHeaders = (
  operator?: OperatorIdentity
): Record<string, string> | undefined => {
  const headers: Record<string, string> = {};
  const email = operator?.email?.trim();
  const token = operator?.token?.trim();
  if (email) {
    headers[OPERATOR_EMAIL_HEADER] = email;
  }
  if (token) {
    headers[OPERATOR_TOKEN_HEADER] = token;
  }
  return Object.keys(headers).length ? headers : undefined;
};

/** An axios request config carrying the operator headers, or undefined. */
export const operatorRequestConfig = (
  operator?: OperatorIdentity
): { headers: Record<string, string> } | undefined => {
  const headers = operatorHeaders(operator);
  return headers ? { headers } : undefined;
};
